var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 104,
    width: 417,
    height: 284,
    rx: 31,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428.917 105.729L264.417 252.333C260.6 255.736 255.665 257.617 250.552 257.617C245.439 257.617 240.504 255.736 236.688 252.333L71.5 105.813C75.4436 104.61 79.5438 103.999 83.6667 104H417C421.035 103.996 425.049 104.579 428.917 105.729ZM457.167 134.583C458.146 138.125 458.667 141.833 458.667 145.667V354C458.667 365.051 454.277 375.649 446.463 383.463C438.649 391.277 428.051 395.667 417 395.667H83.6667C72.616 395.667 62.0179 391.277 54.2039 383.463C46.3899 375.649 42 365.051 42 354V145.667C41.9959 141.908 42.5005 138.165 43.5 134.542L208.958 283.458C220.407 293.661 235.207 299.299 250.542 299.299C265.877 299.299 280.677 293.661 292.125 283.458L457.167 134.583Z",
    fill: "#231942"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.882de5d1e9916c6021cb4fe786d3de96.svg";
export { ForwardRef as ReactComponent };